module.exports = __webpack_public_path__ + "img/signature.3e764ec1.png";